const organizationTypes = {
	seller: 'Seller',
	warehouse: 'Warehouse',
	superAdministrator: 'SuperAdmin',
};

export { organizationTypes };



// WEBPACK FOOTER //
// ./src/common/constants/organizationTypeConstants.js